<div class="dropdown platform-switcher" ref="root">
  <button
    ref="trigger_button"
    type="button"
    class="btn platform-switcher-btn d-inline-flex align-items-center justify-content-center gap-1 p-0 rounded-3"
    aria-haspopup="true"
    :aria-expanded="is_open ? 'true' : 'false'"
    aria-label="Switch platform"
    :disabled="is_loading"
    @click.stop="toggle_menu"
    @keydown.down.prevent="open_menu"
  >
    <span
      class="platform-switcher-badge"
      :class="{ 'platform-switcher-badge-skeleton': is_loading }"
      :style="is_loading ? null : badge_style(current_platform)"
      aria-hidden="true"
    >{{ is_loading ? '' : current_platform.monogram }}</span>
    <i class="bi bi-chevron-down platform-switcher-chevron" aria-hidden="true"></i>
  </button>

  <div
    v-if="is_open"
    class="dropdown-menu dropdown-menu-end show platform-switcher-dropdown shadow border rounded-4 p-0"
    role="menu"
    aria-label="Platforms"
    @click.stop
    @keydown="on_menu_keydown"
  >
    <div class="px-3 py-2 border-bottom">
      <span class="d-block text-uppercase fw-semibold text-muted platform-switcher-eyebrow">Switch platform</span>
    </div>

    <div v-if="has_error" class="p-4 text-center">
      <i class="bi bi-exclamation-triangle text-muted d-block mb-2" aria-hidden="true"></i>
      <p class="mb-2 small text-muted">Couldn't load platforms.</p>
      <button type="button" class="btn btn-sm btn-outline-danger" @click="retry_fetch">Retry</button>
    </div>

    <div v-else class="platform-switcher-grid p-2" role="none">
      <button
        v-for="(platform, index) in sorted_platforms"
        :key="platform.id"
        ref="platform_tile"
        type="button"
        role="menuitem"
        class="platform-switcher-tile d-flex flex-column align-items-center text-center border-0 bg-transparent w-100"
        :class="{ 'is-active': is_current_platform(platform) }"
        :style="tile_style(platform)"
        :aria-current="is_current_platform(platform) ? 'true' : null"
        :tabindex="index === active_index ? 0 : -1"
        :disabled="Boolean(launching_id) && launching_id !== platform.id"
        @click="select_platform(platform)"
      >
        <span class="platform-switcher-tile-icon d-inline-flex align-items-center justify-content-center position-relative" aria-hidden="true">
          <span v-if="launching_id === platform.id" class="spinner-border spinner-border-sm text-danger" role="status"></span>
          <img v-else-if="platform.logo" :src="platform.logo" alt="">
          <span v-else class="platform-switcher-badge" :style="badge_style(platform)">{{ platform.monogram }}</span>
          <i v-if="is_current_platform(platform)" class="bi bi-check platform-switcher-tile-check"></i>
        </span>
        <span class="platform-switcher-tile-name">{{ platform.name }}</span>
      </button>
    </div>

    <div v-if="launch_error" class="px-3 py-2 border-top small text-danger text-center">{{ launch_error }}</div>
  </div>
</div>
